var React = require('react');

function CircleEmptyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.912598 9.07993C0.912598 14.0946 4.97782 18.1599 9.99253 18.1599C15.0072 18.1599 19.0725 14.0946 19.0725 9.07993C19.0725 4.06522 15.0072 0 9.99253 0C4.97782 0 0.912598 4.06522 0.912598 9.07993ZM15.4405 9.08004C15.4405 12.0889 13.0013 14.528 9.99251 14.528C6.98369 14.528 4.54456 12.0889 4.54456 9.08004C4.54456 6.07121 6.98369 3.63208 9.99251 3.63208C13.0013 3.63208 15.4405 6.07121 15.4405 9.08004Z","fill":"currentColor"}));
}

CircleEmptyInline.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = CircleEmptyInline;

CircleEmptyInline.default = CircleEmptyInline;
